<template>
    <v-card outlined class="pa-4">
        <div class="d-flex align-center mb-4">
            <v-icon left color="success">mdi-chart-line</v-icon>
            <span class="text-subtitle-1 font-weight-medium">Výsledky investície</span>
        </div>

        <!-- Key metrics -->
        <!-- <v-row dense class="mb-3">
            <v-col cols="6">
                <div class="text-center">
                    <div class="text-caption">Suma výplat za rok</div>
                    <div class="text-h6 info--text font-weight-bold">
                        {{ formatCurrency(myAnnualPayout) }}
                    </div>
                </div>
            </v-col>
            <v-col cols="6">
                <div class="text-center">
                    <div class="text-caption">Moja účasť %</div>
                    <div class="text-h6 primary--text font-weight-bold">
                        {{ myParticipationPercentage }}%
                    </div>
                </div>
            </v-col>
        </v-row> -->

        <!-- Balance indicators -->
        <!-- <div class="mb-3">
            <div class="d-flex justify-space-between align-center mb-1">
                <span class="text-caption">Stav po 1 roku (len investícia)</span>
                <span :class="yearlyBalanceClass" class="text-caption font-weight-bold">
                    {{ formatCurrency(Math.abs(yearlyBalance)) }}
                    {{ yearlyBalance >= 0 ? 'zisk' : 'chýba' }}
                </span>
            </div>
            <v-progress-linear :value="Math.min(100, Math.max(0, (myAnnualPayout / investmentAmount) * 100))" height="6"
                rounded :color="yearlyBalance >= 0 ? 'success' : 'warning'"></v-progress-linear>
        </div>

        <div class="mb-4">
            <div class="d-flex justify-space-between align-center mb-1">
                <span class="text-caption">Stav po 1 roku (s benefitom)</span>
                <span :class="yearlyBalanceWithBenefitClass" class="text-caption font-weight-bold">
                    {{ formatCurrency(Math.abs(yearlyBalanceWithBenefit)) }}
                    {{ yearlyBalanceWithBenefit >= 0 ? 'zisk' : 'chýba' }}
                </span>
            </div>
            <v-progress-linear :value="Math.min(100, Math.max(0, (myAnnualPayout / payoutClaim) * 100))" height="6"
                rounded :color="yearlyBalanceWithBenefit >= 0 ? 'success' : 'info'"></v-progress-linear>
        </div> -->

        <!-- Summary table -->
        <v-simple-table dense>
            <template v-slot:default>
                <thead>
                    <tr>
                        <th class="text-left text-caption">Popis</th>
                        <th class="text-right text-caption">Suma</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="text-caption">Celková investícia všetkých</td>
                        <td class="text-right text-caption font-weight-medium">
                            {{ formatCurrency(totalRealInvestments) }}
                        </td>
                    </tr>
                    <tr>
                        <td class="text-caption">Skutočne investované + tvoja projekcia</td>
                        <td class="text-right text-caption font-weight-medium">
                            {{ formatCurrency(totalInvestmentsIncludingMine) }}
                        </td>
                    </tr>
                    <tr>
                        <td class="text-caption">Maximum plánovaných investícií</td>
                        <td class="text-right text-caption font-weight-medium">
                            {{ formatCurrency(investmentTargetCapital) }}
                        </td>
                    </tr>
                    <tr>
                        <td class="text-caption">Skutočne treba vyplatiť</td>
                        <td class="text-right text-caption font-weight-medium">
                            {{ formatCurrency(projectedPayoutRequired) }}
                        </td>
                    </tr>
                    <tr>
                        <td class="text-caption">Celkovo treba vrátiť (max)</td>
                        <td class="text-right text-caption font-weight-medium">
                            {{ formatCurrency(23000000) }}
                        </td>
                    </tr>

                </tbody>
            </template>
        </v-simple-table>
    </v-card>
</template>

<script>
import { formatCurrency } from '@/utils/investment-math';
import { INVESTMENT_TARGET_CAPITAL, TOTAL_PAYOUT_EUROS } from '@/config/investment';

export default {
    name: 'CalculatorResults',
    props: {
        paybackPeriod: { type: String, default: '' },
        myAnnualPayout: { type: Number, default: 0 },
        myParticipationPercentage: { type: [Number, String], default: 0 },
        investmentAmount: { type: Number, default: 0 },
        yearlyBalance: { type: Number, default: 0 },
        yearlyBalanceClass: { type: String, default: '' },
        yearlyBalanceWithBenefit: { type: Number, default: 0 },
        yearlyBalanceWithBenefitClass: { type: String, default: '' },
        payoutClaim: { type: Number, default: 0 },
        totalRealInvestments: { type: Number, default: 0 },
        totalInvestmentsIncludingMine: { type: Number, default: 0 },
        totalPayoutClaim: { type: Number, default: 0 }
    },
    computed: {
        investmentTargetCapital() {
            return INVESTMENT_TARGET_CAPITAL;
        },
        projectedPayoutRequired() {
            // "Skutočne treba vyplatiť" is the sum of the system's current claim
            // plus the claim of the newly modeled investment.
            return (this.totalPayoutClaim || 0) + (this.payoutClaim || 0);
        }
    },
    methods: {
        formatCurrency
    }
}
</script>

<style scoped>
.text-h3 {
    font-size: 3rem;
}

@media (max-width: 960px) {
    .text-h3 {
        font-size: 1.8rem !important;
    }
}

.v-progress-linear {
    margin-top: 4px;
}
</style>
